import { Guest } from "@/types/Guest";
import { CreationFieldsRef } from "@/components/PCreateGuest/PCreateGuest";

/**
 * Map a fetched {@link Guest} to the flat {@link CreationFieldsRef} the guest
 * detail form edits. Shared so the initial seed and any post-save re-seed
 * (e.g. pulling in async workflow UPDATE_GUEST results) produce a BYTE-identical
 * shape — the form's dirty check is a JSON.stringify diff, so a divergent mapper
 * would either falsely mark the form dirty or fail to reconcile.
 */
export function guestToCreationFields(guest: Guest): CreationFieldsRef {
  return {
    guestType: guest.guestType || "",
    mainGuest: guest.mainGuest || "",
    firstName: guest?.firstName || "",
    lastName: guest.lastName || "",
    gender: guest.gender || "",
    title: guest.title || "",
    jobTitle: guest.jobTitle || "",
    company: guest.company || "",
    language: guest.language || "",
    email: guest.email || "",
    phone: guest.phone || "",
    mobile: guest.mobile || "",
    address: guest.address || "",
    address2: guest.address2 || "",
    zipCode: guest.zipCode || "",
    city: guest.city || "",
    country: guest.country || "",
    emailOptIn: guest.emailOptIn == null ? "" : guest.emailOptIn.toString(),
    smsOptIn: guest.smsOptIn == null ? "" : guest.smsOptIn.toString(),
    state: guest.state?.toString() || "",
    username: guest.username || "",
    code: guest.code || "",
    additionalFields: guest.additionalFields || {},
    mainGuestDTO: guest.mainGuestDTO,
  };
}
